import React from 'react'
import { Row, Col, Form, Modal, Button, FormControl, Alert } from 'react-bootstrap'
import {findDOMNode} from 'react-dom'

class UserNewForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      employeeType: "client",
      clients: this.props.clients?this.props.clients:[],
      first_name: "",
      last_name: "",
      email: "" ,
      errors: {}
    }
  }

  clientButtonClick(event) {
    $('.client-button').addClass('selected');
    $('.employee-button').removeClass('selected');
    $('.employee-only-fields').hide();
    this.setState({ employeeType: "client" });
  }

  employeeButtonClick(event) {
    $('.employee-button').addClass('selected');
    $('.client-button').removeClass('selected');
    // $('.employee-only-fields').show();
    $('.employee-only-fields').css('display', 'flex');
    this.setState({ employeeType: "employee" });
  }

  toggleAccess(event) {
  }

  accessAll(event) {
    let checkAll = event.target.checked;
    $('.client-list input[type=checkbox]').each((index, el) => {
      $(el).prop("checked", checkAll)
    })
  }

  nextPage() {
    $(".page-1").hide();
    $(".page-2").show();
  }

  backPage() {
    $(".page-2").hide();
    $(".page-1").show();
  }

  searchClients(event) {
    let filter = event.target.value.toLowerCase().trim();
    let visibleClients = [];
    this.props.clients.forEach((client) => {
      let clientName = client.company_name.toLowerCase();
      if (clientName.includes(filter)) {
        visibleClients.push(client);
      }
    })
    this.setState({clients: visibleClients})
  }

  //=========================== FORM VALIDATION START ===================================
  errorChecking = (e) => {
    e.preventDefault();
    const { first_name, last_name, email } = this.state;
    let errors = {};

    if (!first_name.trim()) errors.first_name = true;
    if (!last_name.trim()) errors.last_name = true;
    // if (!email.includes('@')) errors.email = true;
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!emailRegex.test(email)) {
      errors.email = true;
    }

    if (Object.keys(errors).length) {
      this.setState({ errors });
    } else {
      // Proceed with form submission logic here
      console.log('Form is ready to be submitted');
      this.nextPage();
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, errors: { ...this.state.errors, [e.target.name]: false } });
  };

//=========================== FORM VALIDATION END ===================================


  render() {
    const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;
    let clientIcon = require("images/lite/icons/handshake.svg");
    clientIcon = <img className="client-icon" src={`/datapulse${clientIcon}`} />;
    let employeeIcon = require("images/lite/icons/user-two.svg");
    employeeIcon = <img className="employee-icon" src={`/datapulse${employeeIcon}`} />;
    const errorClass = "lite-invalid-input";
    console.log(this.state.errors)

    return (
      <>
        <Button className="lite-btn btn-success" onClick={(e) => this.setState({show: true})}>
          + Add user
        </Button>
        <Modal className="new-user-modal" show={this.state.show} onHide={(e) => this.setState({show: false})}>
          <Form className="new-user-form" action={this.props.createUserPath} method={this.props.pathMethod}>
            <input hidden name="authenticity_token" value={authenticityToken} readOnly />
            <div className="page-1">
              <Modal.Header closeButton>
                <Modal.Title>
                  <h4>
                    Add New User - Basic Info
                  </h4>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>I want to add a new:</p>

                <div className="mt-3 new-user-type d-flex gap-24 justify-content-center">
                  <div className="client-button selected" onClick={(e) => {this.clientButtonClick(e)}}>
                    {clientIcon}
                    <h4>Client</h4>
                  </div>
                  <Form.Control type="hidden" name="client" className="client-employee-field" value={this.state.employeeType == "client" ? "1" : "0"} />

                  <div className="employee-button" onClick={(e) => {this.employeeButtonClick(e)}}>
                    {employeeIcon}
                    <h4>Employee</h4>
                  </div>
                  <Form.Control type="hidden" name="employee" className="dp-employee-field" value={this.state.employeeType == "employee" ? "1" : "0"} />
                </div>

                <div className="new-user-info d-flex gap-24 justify-content-center">
                  <div className="all-employee-fields d-flex flex-column gap-4">
                    <div className="lite-form-group">
                      <label>First Name</label>
                      <input
                        type="text"
                        name="first_name"
                        value={this.state.first_name}
                        onChange={this.handleChange}
                        className={`lite-input ${this.state.errors.first_name ? errorClass : ""}`}
                      />
                    </div>
                    <div className="lite-form-group">
                      <label>Last Name</label>
                      <input
                        type="text"
                        name="last_name"
                        value={this.state.last_name}
                        onChange={this.handleChange}
                        className={`lite-input ${this.state.errors.last_name ? errorClass : ""}`}
                      />
                    </div>
                    <div className="lite-form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        name="email"
                        value={this.state.email}
                        onChange={this.handleChange}
                        className={`lite-input ${this.state.errors.email ? errorClass : ""}`}
                      />
                    </div>
                  </div>

                  <div className="employee-only-fields flex-column gap-4" style={{"display": "none"}}>
                    <div className="lite-form-group">
                      <label>Employee Level:</label>
                      <div className="select-wrapper">
                        <select name="role" className="lite-select">
                          <option value="Employee" default>Restricted</option>
                          <option value="Specialist">Standard</option>
                          <option value="Manager">Full</option>
                          <option value="Admin">Admin</option>
                        </select>
                      </div>
                    </div>
                    <div className="lite-form-group">
                      <label>Employee Department:</label>
                      <div className="select-wrapper">
                        <select name="department" className="lite-select">
                          <option value="None" default>None</option>
                          <option value="SEO">SEO</option>
                          <option value="PPC">PPC</option>
                          <option value="Both">SEO and PPC</option>
                          <option value="DEV">Development</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button type="button" className="lite-btn btn-default mr-3" onClick={(e) => this.setState({show: false})}>Cancel</button>
                <button type="button" className="lite-btn btn-success" onClick={this.errorChecking}>Continue to access</button>
              </Modal.Footer>
            </div>
            <div className="page-2" style={{"display": "none"}}>
              <Modal.Header closeButton>
                <Modal.Title><h4>Add New User - Account Access</h4></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p onClick={this.backPage} className="back-btn text-info mb-2"><i className="fas fa-arrow-left pr-2"></i>Back to Basic Info</p>
                <div className="d-flex justify-content-between flex-wrap">
                  <div className="client-search">
                    <span className="fa fa-search"></span>
                    <input onChange={(e) => this.searchClients(e)} placeholder="Search accounts..." />
                  </div>
                  <div className="select-all">
                    <div className="custom-control custom-checkbox">
                      <input type="checkbox" onChange={(e) => {this.accessAll(e)}} className="custom-control-input" id='toggle-all-access' />
                      <label className="custom-control-label" htmlFor="toggle-all-access">Select All</label>
                    </div>
                  </div>
                </div>
                <Row>
                  <Col> 
                    <ul className="client-list">
                      {
                        this.state.clients.map((client) => {
                          return (
                            <li key={client.company_name}>
                              <Form.Group>
                                <div className="custom-control custom-checkbox">
                                  <input type="checkbox" onChange={(e) => {this.toggleAccess(e)}} name={`account_access_ids[${client.id}]`} className="custom-control-input" id={`account-access-id-${client.id}`} />
                                  <label className="custom-control-label" htmlFor={`account-access-id-${client.id}`}>{client.company_name}</label>
                                </div>
                              </Form.Group>
                            </li>
                          )
                        })
                      }
                    </ul>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <button type="button" className="lite-btn btn-default mr-3" onClick={(e) => this.setState({show: false})}>Cancel</button>
                <button type="submit" className="lite-btn btn-success">Create user</button>
              </Modal.Footer>
            </div>
          </Form>
        </Modal>
      </>
    );
  }
}

export default UserNewForm;
